import styled from '@xstyled/styled-components'
import { Skeleton } from '../skeleton'

export type HeightRange = {
  minHeight: number
  maxHeight: number
}

export function getHeight(size: DotProps['size']): HeightRange {
  const factor = size === 'l' ? 2 : 1
  let range: HeightRange = { minHeight: 3, maxHeight: 20 }
  for (const k in range) {
    range[k as keyof HeightRange] = range[k as keyof HeightRange] * factor
  }
  return range
}

export function getWidth(size: DotProps['size']): number {
  return size === 'l' ? 4 : 3
}

export function getWaveWidth(size: DotProps['size']): number {
  return getWidth(size) * 2
}

export interface DotProps {
  variant: 'normal' | 'elapsed'
  size: 'l' | 'm'
}

const commonProps = (props: DotProps) => ({
  ...getHeight(props.size),
  width: getWidth(props.size),
  ':not(:first-child)': {
    marginLeft: getWidth(props.size)
  },
  borderRadius: getWidth(props.size) + 1
})

export const Dot = styled.div<DotProps>(
  props => ({
    backgroundColor:
      props.variant === 'normal'
        ? props.theme.colors.grey.l1
        : props.theme.colors.primary.base
  }),
  commonProps
)

export const DotSkeleton = styled(Skeleton)<DotProps>(commonProps)

export const StyledWaveform = styled.divBox({
  display: 'flex',
  alignItems: 'center',
  height: 40
})
